import { facadeApi } from 'helpers/api.helper';

export const getRefreshToken = () => facadeApi.post('/assignment/token/refresh');
